export default __webpack_public_path__ + "static/media/recurring-icon17.084d029c.png";